<template>
  <div class="col-md-12 mx-auto">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">

        <back-arrow :bilan-type="bilanType"
                    :params="{operationId: operationId}"
                    :sub-title-ope="operationName"
                    :title="getTitle()"/>
        <div>
          <button v-if="isDevisValidated()" class="show-action-btn add mr-1" @click="clickOnAddFactureBtn()">
            <plus-icon size="18"/>
          </button>
          <button class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
          <button class="show-action-btn delete" @click="clickOnDeleteBtn()">
            <trash-icon size="18"/>
          </button>
        </div>
      </div>

      <div v-if="isLoading" class="row">
        <div class="col-md-12 text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Chargement...</span>
          </div>
        </div>
      </div>

      <div v-else-if="isDataLoaded" class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <!-- Informations générales -->
            <div class="row">
              <div class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('Informations générales') }}
                </div>
              </div>

              <!-- 1. Numéro -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Numéro') }} :</div>
                  <div>{{ getNumeroDevis() }}</div>
                </div>
              </div>

              <!-- 2. Artisan -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Artisan') }} :</div>
                  <div>{{ item.artisan || 'N/A' }}</div>
                </div>
              </div>

              <!-- 3. Travaux (Nom du poste) -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Travaux') }} :</div>
                  <div>{{ item.nom || 'N/A' }}</div>
                </div>
              </div>

              <!-- 4. Lot(s) -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Lot(s)') }} :</div>
                  <div>{{ getLots() }}</div>
                </div>
              </div>

              <!-- 5. Prix TTC (montant devis) -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t(`devis.Prix${isHT ? 'HT' : 'TTC'}`) }} :</div>
                  <div>{{ getMontantDevis() }}</div>
                </div>
              </div>

              <!-- 6. Taux TVA -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Taux TVA') }} :</div>
                  <div>{{ getTauxTVA() }}</div>
                </div>
              </div>

              <!-- 7. Statut du devis -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Statut') }} :</div>
                  <div>
                    <span :class="getDevisStatusClass(getDevisStatus())" class="status-badge-small">
                      {{ getDevisStatusText(getDevisStatus()) }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Documents du devis -->
              <div v-if="item.devis && getDevisDocuments().length > 0" class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('Document') }}
                </div>
                <div v-for="document in getDevisDocuments()" :key="document.id" class="mb-2">
                  <b-link class="light-blue-color underline-text" @click="getDocument(document.fileUrl)">
                    <i class="fas fa-file-alt mr-1"></i>
                    {{ document.fileName }}
                  </b-link>
                </div>
              </div>
            </div>

            <!-- Section Date travaux -->
            <div class="row mt-4">
              <div class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('Date travaux') }}
                </div>
              </div>

              <!-- 1. Début des travaux -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Début des travaux') }} :</div>
                  <div>{{ getDateDebut() }}</div>
                </div>
              </div>

              <!-- 2. Fin des travaux -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Fin des travaux') }} :</div>
                  <div>{{ getDateFin() }}</div>
                </div>
              </div>

              <!-- 3. Colonne vide pour maintenir l'alignement -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2"></div>
                  <div></div>
                </div>
              </div>
            </div>

            <!-- Section Échéancier et Factures côte à côte -->
            <div v-if="item.devis.schedule && item.devis.schedule.paiements && item.devis.schedule.paiements.length"
                 class="row mt-2">
              <div class="col-md-6 bold-text level-two-title my-2 main-red-color">
                {{ $t('Échéancier de paiement') }}
              </div>

              <div v-for="(paiement, index) in item.devis.schedule.paiements" :key="index" class="col-12 mb-3">
                <div class="d-flex align-items-center">
                  <div class="mr-1">
                    {{ paiement.name || ('Paiement ' + (index + 1)) }} le
                  </div>
                  <div>
                    {{ formatDate(paiement.date) }} :
                    {{ formatEuro(paiement.amount) }} ({{ isHT ? 'HT' : 'TTC' }})
                  </div>
                </div>
              </div>

              <!-- Bloc Factures (50% droite) -->
              <div v-if="item.factures && item.factures.length > 0" class="col-md-6">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('Factures') }}
                </div>

                <div v-for="(facture, index) in item.factures" :key="facture.id" class="mb-4">
                  <!-- Nom de la facture -->
                  <div class="mb-2">
                    <div class="d-flex align-items-center">
                      <div>
                        <span class="facture-label-link bold-text" @click="goToFactureShow(facture)">
                          {{ facture.libelle || 'N/A' }}
                        </span>
                        <span class="bold-text"> ( {{ convertCentimesToEuros(facture.montant) }} )</span>
                      </div>
                    </div>
                  </div>


                  <!-- Documents de la facture -->
                  <div v-if="facture.documents && facture.documents.length > 0" class="mb-2">
                    <div v-for="document in facture.documents" :key="document.id" class="mb-1">
                      <b-link class="light-blue-color underline-text" @click="getDocument(document.fileUrl)">
                        <i class="fas fa-file-alt mr-1"></i>
                        {{ document.fileName }}
                      </b-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Message si pas de devis ni factures -->
            <div v-if="!item.devis && (!item.factures || item.factures.length === 0)" class="row mt-4">
              <div class="col-md-12">
                <div class="text-center text-muted">
                  <p>{{ $t('Aucun devis ou facture associé à ce poste') }}</p>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <!-- Modale de confirmation de suppression -->
    <b-modal
      id="delete-confirmation-modal"
      cancel-title="Annuler"
      centered
      ok-title="Supprimer"
      ok-variant="danger"
      title="Confirmation de suppression"
      @cancel="cancelDelete"
      @ok="confirmDelete">

      <div v-if="item">
        <p class="mb-3">
          {{ $t('Avertissment.delete.poste') }} <strong>{{ item.nom }}</strong> ?
        </p>
        <div class="alert alert-warning">
          <i class="fas fa-exclamation-triangle mr-2"></i>
          <strong>{{ $t('Attention') }}</strong> {{ $t('action.delete.cascade') }} :
          <ul class="mb-0 mt-2">
            <li>{{ $t('all.factures.associated') }}</li>
            <li>{{ $t('all.devis.associated') }}</li>
            <li>{{ $t('poste/honoraire.conserved') }}</li>
          </ul>
        </div>
      </div>
    </b-modal>

    <!-- Modal de choix d'édition -->
    <b-modal
      id="edit-choice-modal"
      :title="$t('Modifier')"
      centered
      hide-footer
      @hidden="hideEditModal">

      <div>
        <p class="mb-4">{{ $t('Que souhaitez-vous modifier ?') }}</p>

        <div class="row">
          <div class="col-md-6">
            <b-button
              block
              class="mb-3"
              size="lg"
              variant="primary"
              @click="editDevis">
              <i class="fas fa-file-invoice mr-2"></i>
              {{ $t('Modifier') }} {{ $t('devis') }}
            </b-button>
          </div>
          <div class="col-md-6">
            <b-button
              block
              class="mb-3"
              size="lg"
              variant="primary"
              @click="showFacturesList">
              <i class="fas fa-receipt mr-2"></i>
              {{ $t('Modifier') }} {{ $t('factures') }}
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal de liste des factures -->
    <b-modal
      id="factures-list-modal"
      :title="$t('Sélectionner une facture à modifier')"
      centered
      hide-footer
      @hidden="resetFacturesList">

      <div v-if="facturesList.length > 0">
        <p class="mb-4">{{ $t('Choose.modify.facture') }}</p>

        <div class="factures-list">
          <div
            v-for="facture in facturesList"
            :key="facture.id"
            class="facture-item mb-3 p-3 border rounded cursor-pointer"
            @click="editFacture(facture)">

            <div class="d-flex justify-content-between align-items-center">
              <div>
                <strong>{{ facture.nom || facture.numero }}</strong>
                <div class="text-muted">
                  {{ convertCentimesToEuros(facture.montant || facture.prixTTC) }} - {{
                    formatDate(facture.dateEmission)
                  }}
                </div>
              </div>
              <div>
                <span :class="getStatusClass(facture.status)" class="status-badge-small">
                  {{ getStatusText(facture.status) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="text-center">
        <p class="text-muted">{{ $t('Aucune facture associée à ce poste') }}</p>
      </div>
    </b-modal>

    <!-- Modal de sélection des devis -->
    <b-modal
      id="devis-list-modal"
      :title="$t('Sélectionner un devis à modifier')"
      centered
      hide-footer
      @hidden="resetDevisList">

      <div v-if="devisList.length > 0">
        <p class="mb-4">{{ $t('Choisissez le devis à modifier :') }}</p>

        <div class="devis-list">
          <div
            v-for="(devis, index) in devisList"
            :key="devis.id"
            class="devis-item mb-3 p-3 border rounded cursor-pointer"
            @click="editSpecificDevis(devis)">

            <div class="d-flex justify-content-between align-items-center">
              <div>
                <strong>{{ $t('Devis') }} {{ index + 1 }} - N°{{ devis.numero || 'N/A' }}</strong>
                <div class="text-muted">
                  {{ convertCentimesToEuros(devis.montant) }} - {{ devis.tauxTVA || 'N/A' }}% TVA
                </div>
              </div>
              <div>
                <span :class="getDevisStatusClass(devis.status)" class="status-badge-small">
                  {{ getDevisStatusText(devis.status) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="text-center">
        <p class="text-muted">{{ $t('Aucun devis associé à ce poste') }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from "../../services/api"
import BackArrow from "../../components/b122/BackArrow"

export default {
  name: "OperationDevisFactureShow",

  components: {
    BackArrow
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      devisId: this.$route.params.devisId,
      item: {},
      operationName: '',
      bilanType: '',
      isLoading: true,
      isDataLoaded: false,
      facturesList: [],
      devisList: [],
      isHT: false
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      try {
        await this.getOperation()

        const devisResponse = await api.get(`/operationDevis/${this.devisId}`)
        const devis = devisResponse.data

        const formData = new FormData()
        formData.append('restrictbylong-operationId', this.operationId)
        formData.append('perPage', '1000')
        formData.append('currentPage', '1')
        formData.append('sortBy', '')
        formData.append('sortDesc', 'false')
        formData.append('filters', '[]')

        const facturesResponse = await api.post(`/operationDevisFacture/getB122TableResults`, formData)
        const items = facturesResponse.data.items || facturesResponse.data.results || facturesResponse.data

        const matchingItems = items.filter(item => {
          return (
            item.operationDevisFacture &&
            item.operationDevisFacture.devis &&
            item.operationDevisFacture.devis.id == this.devisId
          )
        })

        if (matchingItems.length) {
          let factures = []
          let foundItem = {}
          matchingItems.forEach(item => {
            foundItem = item
            if(item.operationDevisFacture.factures[0]) {
              factures.push(item.operationDevisFacture.factures[0])
            }
          })
          this.item = foundItem.operationDevisFacture
          this.item = {...this.item, devis: devis}
          this.item.factures = factures
        } else {

          this.item = {
            devis: devis,
            factures: [],
            nom: devis.posteName || 'N/A',
            artisan: (devis.artisan ? devis.artisan.toString() : 'N/A'),
            sourceType: 'devis',
            montantTotal: devis.prixTTC || 0,
            montantPaye: 0
          }
        }

        this.isDataLoaded = true
        this.isLoading = false
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error)
        this.$router.push({
          name: 'OperationDevisFacturesIndex',
          params: {operationId: this.operationId}
        })
      }
    },

    async getOperation() {
      try {
        const response = await api.get(`/operation/${this.operationId}`)
        this.operationName = response.data.name || response.data.toString
        this.bilanType = response.data.bilanType
        this.isHT = response.data.isHT
      } catch (error) {
        console.error('Erreur lors de la récupération de l\'opération:', error)
      }
    },

    getTitle() {
      if (!this.isDataLoaded || !this.item) {
        return this.$t('Devis')
      }

      const numero = this.getNumero()
      if (numero !== 'N/A' && this.item.artisan) {
        return `${this.$t('Devis')} N°${numero} - ${this.item.artisan}`
      } else if (numero !== 'N/A') {
        return `${this.$t('Devis')} N°${numero}`
      } else if (this.item.artisan) {
        return `${this.$t('Devis')} - ${this.item.artisan}`
      } else {
        return this.$t('Devis')
      }
    },

    getNumero() {
      if (this.item.devis && this.item.devis.numero) {
        return this.item.devis.numero || 'N/A'
      }
      return 'N/A'
    },

    getNumeroDevis() {
      if (this.item.devis && this.item.devis.numero) {
        return this.item.devis.numero || 'N/A'
      }
      return 'N/A'
    },

    getMontantDevis() {
      if (this.item.devis && this.item.devis.prixTTC != null) {
        if (this.isHT) {
          return this.formatEuro(this.item.devis.prixHT)
        } else {
          return this.formatEuro(this.item.devis.prixTTC)
        }
      }
      return 'N/A'
    },

    getDevisStatus() {
      if (this.item.devis && this.item.devis.status) {
        return this.item.devis.status
      }
      return null
    },

    getDevisDocuments() {
      if (this.item.devis && this.item.devis.documents) {
        return this.item.devis.documents
      }
      return []
    },

    getTypeLabel() {
      return this.item.sourceType === 'construction' ? this.$t('Travaux') : this.$t('Honoraires')
    },

    getLots() {
      return this.item.lotsInfo || 'N/A'
    },

    getTauxTVA() {
      if (this.item.devis && this.item.devis.tauxTVA) {
        return this.item.devis.tauxTVA || 'N/A'
      }
      return 'N/A'
    },

    getNumeroTVAArtisan() {
      if (this.item.devis && this.item.devis.list && this.item.devis.list.length > 0) {
        const devis = this.item.devis.list[0]
        if (devis.numeroTVA) {
          return devis.numeroTVA
        }
      }

      if (this.item.artisanNumeroTVA) {
        return this.item.artisanNumeroTVA
      }

      return null
    },

    getDateDebut() {
      return this.item.dateDebut || 'N/A'
    },

    getDateFin() {
      return this.item.dateFin || 'N/A'
    },

    getStatusClass(status) {
      switch (status) {
        case 'PAYE':
        case 'PAID':
          return 'status-paye'
        case 'A_PAYER':
        case 'UNPAID':
          return 'status-a-payer'
        case 'RESTE_A_PAYER':
          return 'status-reste-a-payer'
        case 'EN_ATTENTE':
        case 'PENDING':
          return 'status-en-attente'
        default:
          return 'status-default'
      }
    },


    convertCentimesToEuros(centimes) {
      if (!centimes && centimes !== 0) return '-'

      const euros = (centimes / 100).toFixed(2)
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
      })
      return formatter.format(euros)
    },

    formatEuro(montant) {
      if (!montant && montant !== 0) return '-'

      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
      })
      return formatter.format(montant)
    },

    calculateMontantAPayer() {
      const montantTotal = this.item.montantTotal || 0
      const montantPaye = this.item.montantPaye || 0
      return Math.max(0, montantTotal - montantPaye)
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A'
      try {
        const parts = dateString.split('-')
        if (parts.length === 3) {
          return `${parts[2]}/${parts[1]}/${parts[0]}`
        }
        return dateString
      } catch (error) {
        console.error('Erreur formatage date:', error)
        return dateString
      }
    },

    getDocument(fileUrl) {
      let url = process.env.SERVER_URL + fileUrl
      window.open(url, '_blank').focus()
    },

    clickOnEditBtn() {
      this.editDevis()
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('delete-confirmation-modal')
    },

    async confirmDelete() {
      try {
        await api.delete(`/operationDevis/${this.devisId}`)

        this.successToast(this.$t('Devis') + ' "' + this.getNumeroDevis() + '" ' + this.$t('deleted'))

        this.$router.push({
          name: 'OperationDevisFacturesIndex',
          params: {operationId: this.operationId}
        })
      } catch (error) {
        console.error('Erreur lors de la suppression:', error)
        this.$bvToast.toast(this.$t('Erreur lors de la suppression'), {
          variant: 'danger',
          solid: true
        })
      }
    },

    cancelDelete() {

    },

    editDevis() {
      if (this.item && this.item.devis && this.item.devis.id) {
        this.editSpecificDevis(this.item.devis)
      } else if (this.item && this.item.sourceType) {
        if (this.item.sourceType === 'construction') {
          this.$router.push({
            name: 'OperationConstructionEdit',
            params: {
              operationId: this.operationId,
              constructionId: this.item.relatedSourceIds[0]
            }
          })
        } else if (this.item.sourceType === 'honoraire') {
          this.$router.push({
            name: 'OperationHonoraireEdit',
            params: {
              operationId: this.operationId,
              honoraireId: this.item.relatedSourceIds[0]
            }
          })
        }
      }
    },

    async showFacturesList() {

      this.$bvModal.hide('edit-choice-modal')

      try {


        if (this.item && this.item.factures && this.item.factures.length > 0) {
          this.facturesList = this.item.factures

        } else {
          this.facturesList = []

        }


        setTimeout(() => {
          this.$bvModal.show('factures-list-modal')
        }, 300)
      } catch (error) {
        console.error('Erreur lors de la récupération des factures:', error)
        this.$bvToast.toast(this.$t('Erreur lors de la récupération des factures'), {
          variant: 'danger',
          solid: true
        })
      }
    },

    editFacture(facture) {

      this.$router.push({
        name: 'OperationFactureEdit',
        params: {
          operationId: this.operationId,
          factureId: facture.id
        },
        query: {from: 'OperationDevisFactureShow'}
      })
    },

    goToFactureShow(facture) {
      if (facture && facture.id) {
        this.$router.push({
          name: 'OperationFactureShow',
          params: {
            operationId: this.operationId,
            factureId: facture.id
          },
          query: {from: 'OperationDevisFactureShow'}
        })
      }
    },

    resetFacturesList() {
      this.facturesList = []
    },


    editSpecificDevis(devis) {

      this.$bvModal.hide('edit-choice-modal')
      this.$bvModal.hide('devis-list-modal')

      this.$router.push({
        name: 'OperationDevisEdit',
        params: {
          operationDevisId: devis.id,
          operationId: this.operationId
        },
        query: {from: 'OperationDevisFactureShow'}
      })
    },

    resetDevisList() {
      this.devisList = []
    },

    hideEditModal() {

    },

    getStatusText(status) {
      switch (status) {
        case 'PAYE':
        case 'PAID':
          return this.$t('status.paye')
        case 'A_PAYER':
        case 'UNPAID':
          return this.$t('status.aPayer')
        case 'RESTE_A_PAYER':
          return this.$t('status.resteAPayer')
        case 'EN_ATTENTE':
        case 'PENDING':
          return this.$t('status.enAttente')
        default:
          return status
      }
    },

    getDevisStatusText(status) {
      switch (status.value) {
        case 'DRAFT':
          return 'Brouillon'
        case 'WAITING':
          return 'En attente'
        case 'VALIDATED':
          return 'Validé'
        case 'REFUSED':
          return 'Refusé'
        case 'EXPIRED':
          return 'Expiré'
        default:
          return status.value
      }
    },

    getDevisStatusClass(status) {
      switch (status.value) {
        case 'VALIDATED':
          return 'status-paye'
        case 'DRAFT':
        case 'WAITING':
          return 'status-en-attente'
        case 'REFUSED':
        case 'EXPIRED':
          return 'status-a-payer'
        default:
          return 'status-default'
      }
    },

    isDevisValidated() {
      return this.item.devis && this.item.devis.status === 'VALIDATED'
    },

    clickOnAddFactureBtn() {
      this.$router.push({
        name: 'OperationFactureCreate',
        params: {
          operationId: this.operationId,
        },
        query: {
          from: 'OperationDevisFactureShow'
        }
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
/* Badge de statut moderne avec radius */
.status-badge {
  display: inline-block;
  padding: 6px 12px;
  font-size: 0.85rem;
  font-weight: 500;
  text-align: center;
  border-radius: 1000px;
  min-width: 120px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

/* Badge de statut petit pour les factures */
.status-badge-small {
  display: inline-block;
  padding: 4px 8px;
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  border-radius: 1000px;
  min-width: 80px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

/* Éléments de facture cliquables */
.facture-item {
  transition: all 0.2s ease;
  border: 1px solid #dee2e6 !important;
}

.facture-item:hover {
  background-color: #f8f9fa;
  border-color: #007bff !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.cursor-pointer {
  cursor: pointer;
}

/* Payé - Vert clair avec texte vert foncé */
.status-paye {
  background-color: #317B221A;
  color: #317B22;
}

/* À payer - Rouge clair avec texte rouge foncé */
.status-a-payer {
  background-color: #9E04301A;
  color: #9E0430;
}

/* Reste à payer - Orange clair avec texte orange foncé */
.status-reste-a-payer {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

/* En attente - Bleu clair avec texte bleu foncé */
.status-en-attente {
  background-color: #009DFF1A;
  color: #009DFF;
}

/* Par défaut - Gris clair */
.status-default {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

/* Styles pour les éléments de devis cliquables dans les modales */
.devis-item {
  transition: all 0.2s ease;
  border: 1px solid #dee2e6 !important;
}

.devis-item:hover {
  background-color: #f8f9fa;
  border-color: #007bff !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Lien cliquable pour le libellé de facture */
.facture-label-link {
  font-weight: 600;
  text-decoration: underline;
  color: #000;
  cursor: pointer;
}

.facture-label-link:hover {
  color: var(--main-color-hover);
}

/* Style pour le bouton d'ajout de facture */
.show-action-btn.add {
  background-color: var(--main-color);
}

.show-action-btn.add:hover {
  background-color: var(--main-color-hover);
}

</style>




// WEBPACK FOOTER //
// src/views/operationDevisFactures/OperationDevisFactureShow.vue